import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si trabajo solo en consultorio privado o solo para centros?',
  answer: 'Está pensado principalmente para nutricionistas independientes que trabajan solos o en consultorio pequeño. Todo el sistema de cobro, evoluciones y seguimiento está diseñado para que lo manejés vos sin depender de nadie más. Si trabajás en un centro también lo podés aplicar, pero el foco es la práctica autogestionada.'
}, {
  question: '¿Los materiales son editables?',
  answer: 'Sí. Los documentos vienen en formatos editables para que puedas poner tu nombre, logo y datos. Los checklists, evoluciones y contratos son tuyos para personalizar como necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Los 6 bonos están incluidos en las dos opciones. Si además querés el sistema completo de marca, marketing y negocio — con Autoridad Nutricional™, los documentos legales y el calendario de contenido — el Megapack Pro es la opción más inteligente.'
}, {
  question: '¿Sirve si soy recién recibido con poca experiencia?',
  answer: 'Es ideal para eso. Todo está explicado con criterio clínico pero en lenguaje claro y aplicable desde el primer día. No asume que ya sabés todo — te da el marco para trabajar con seguridad aunque estés empezando a construir tu práctica.'
}, {
  question: '¿Funciona para todo tipo de pacientes?',
  answer: 'Sí. Los 6 tomos cubren desde la primera consulta hasta el seguimiento a largo plazo, con planes adaptables por patología, edad, peso, nivel socioeconómico y objetivos. No es contenido genérico — es un sistema clínico con criterio profesional real.'
}, {
  question: '¿Qué pasa si atiendo pacientes con patologías complejas?',
  answer: 'El Tomo 4 tiene el sistema de seguimiento y el Bono de Guía de Derivación Inteligente. No reemplaza el juicio clínico, pero te da un marco estructurado para tomar decisiones, documentarlas y comunicarlas con seguridad. Muchos profesionales lo usan exactamente en esos casos.'
}, {
  question: '¿Qué diferencia tiene con otros materiales de nutrición del mercado?',
  answer: 'La mayoría de los materiales que existen son teóricos o están pensados para la formación académica. Este sistema está diseñado para la práctica real: planes listos para personalizar, material para entregar al paciente, sistema de cobro, retención y comunicación. No es un libro — es una caja de herramientas lista para trabajar.'
}, {
  question: '¿Por qué elegir el Megapack Pro y no el estándar?',
  answer: 'El Megapack te da el sistema clínico completo. El Pro le agrega el sistema de negocio: cómo cobrar, cómo retener pacientes, cómo construir autoridad en redes y cómo posicionarte como referente. Si querés trabajar mejor, el Megapack alcanza. Si querés además crecer como profesional y ganar lo que merecés, el Pro es la decisión obvia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(220,252,231) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-143">
      <div className="mx-auto max-w-4xl" data-id="element-144">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-145">
          Preguntas <span className="text-green-700" data-id="element-146">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-147">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-148">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(34, 197, 94, 0.5)' : '1px solid rgba(34, 197, 94, 0.15)'
          }} data-id="element-149">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-150">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#15803d' : '#111827'
              }} data-id="element-151">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#15803d',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-152">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(34, 197, 94, 0.1)'
            }} data-id="element-153">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-154">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>

      </div>
    </section>;
}